import {
  Box,
  Button,
  Divider,
  Heading,
  HStack,
  Text,
  Flex,
  Skeleton,
  Stack
} from '@chakra-ui/react'
import React from 'react'

const AdditionalDetails = ({ title, row1, row2, status }) => {
  
  return (
    <Box shadow={'md'} rounded={'md'} border={'1px'} borderColor={'gray.200'} bgColor={'#FFFFFF'} my={5} p={3}>
      <Flex justifyContent={'space-between'}>
        <Box>
          <Heading size={'md'} mb={2}>{`Additional ${(title !== "Main Return" && title !== "Delivery Return") ? title : ''} Details`}</Heading>
        </Box>
      </Flex>
      <Divider size={1} my={2} borderBottomColor={'black'} />
      <HStack spacing={10} py={2} my={2} justifyContent={'space-between'}>
        {row1.map((r, i) => (
          <Box key={i} >
            <Text fontWeight={'bold'} fontSize={'md'} color={'blackAlpha.500'}>{Object.keys(r)[0]}</Text>
            <Text fontWeight={'semibold'} fontSize={'sm'}>{r[Object.keys(r)[0]]}</Text>
          </Box>
        ))}

         {/* Status Bar Row 1 */}
         {(title==="Order" || title==="Settlement" || title === "Delivery" || title === "Delivery Return" || title === "Main Return" ) &&
          <Box>
            <Text fontWeight={'bold'} fontSize={'md'} color={'blackAlpha.500'}>Status</Text>
            {status === undefined ?
          <Stack w={20}>
            <Skeleton height="5px"/>
            <Skeleton height="5px"/>
          </Stack>
              :<Button size={'xs'} colorScheme={'pink'} rounded={'full'}>{status}</Button>
            }
          </Box>}
      </HStack>
      <HStack spacing={10} py={2} my={2} justifyContent={'space-between'}>
      {row2.map((r, i) => (
          Object.keys(r).length > 0 &&
            <Box key={i} flexBasis={'26%'}>
              <Text fontWeight={'bold'} fontSize={'md'} color={'blackAlpha.500'}>{Object.keys(r)[0]}</Text>
              <Text fontWeight={'semibold'} fontSize={'sm'}>{r[Object.keys(r)[0]]}</Text>
            </Box>
          
        ))}

        {/* Status Bar Row 2 */}
        {(title === "Tenure" || title === "Dispute" ) &&
          <Box>
            <Text fontWeight={'bold'} fontSize={'md'} color={'blackAlpha.500'}>Status</Text>
            {status === undefined ?
          <Stack w={20}>
            <Skeleton height="5px"/>
            <Skeleton height="5px"/>
          </Stack>
              :<Button size={'xs'} colorScheme={'pink'} rounded={'full'}>{status}</Button>
            }
          </Box>}

        {/* Customer Verification */}
         {title === "Customer" &&
              <>
              <Box flexBasis={'33%'}>
                <Text fontWeight={'bold'} fontSize={'md'} color={'blackAlpha.500'}>Customer Status</Text>
                <Button size={'sm'} colorScheme={status[1].verificationStatus === 'Pending' ? 'telegram' : status[1].verificationStatus === 'Awaiting' ? 'cyan'  : status[1].verificationStatus === 'Cancelled' ? 'red' : 'green' }  rounded={'full'} width={'70%'} cursor={'default'}>{status[0].customerStatus}</Button>
              </Box>
              <Box flexBasis={'33%'}>
                <Text fontWeight={'bold'} fontSize={'md'} color={'blackAlpha.500'}>Verification Status</Text>
                <Button size={'sm'} colorScheme={status[1].verificationStatus === 'Pending' ? 'telegram' : status[1].verificationStatus === 'Awaiting' ? 'cyan'   : status[1].verificationStatus === 'Cancelled' ? 'red' : 'green' } cursor={'default'} rounded={'full'} width={'70%'}>{status[1].verificationStatus}</Button>
            </Box>
            </>}
      </HStack>
    </Box>
  )
}

export default AdditionalDetails
